<!-- Builder Start -->
<div id="{{position}}" class="position-relative">
  <div *ngIf="!loading">
    <div class="app-header-background" [ngStyle]="{'background-color':backgroundColor}"
      [ngClass]="activatePadding?'header-padding-top':''"
      [attr.data-aos]="allElementAnimation ? allElementAnimation : null">
      <div *ngIf="title" class="app-header-headline app-ecommerce-title"
        [attr.data-aos]="textAnimation ? textAnimation : null">
        <h1 [ngStyle]="{ 'font-family': titleFontFamily ? titleFontFamilyName : '' ,'color': titleColor?titleColor:textColor,'font-weight':fontWeight }" class="mat-h1"
          [ngClass]="[titleSize]" [innerHtml]="title | safeHtml"></h1>
      </div>
      <!-- Photo Grid -->
      <div class="container-gird-list" [ngStyle]="{'max-width':maxWidth+'px'}"
        [attr.data-aos]="itemsAnimation ? itemsAnimation : null">
        <div *ngIf="(products$ | async) as products" class="products" fxLayout="column" fxLayout.gt-sm="row wrap"
          fxLayoutAlign="center">

          <div *ngFor="let product of products;let i = index" class="product" fxFlex="1 1" fxFlexAlign="center"
            [ngStyle]="{'-ms-flex': (100/nbrProductsPerLine)+'%', 'flex':(100/nbrProductsPerLine)+'%', 'max-width':(100/nbrProductsPerLine)+'%','padding':'0 4px'}">
            <div>
              <a [routerLink]="[links[i]]"><img *ngIf="product && product.images && product.images[0] && product.images[0].preview_m_url" [src]="product.images[0].preview_m_url" alt=""></a>
            </div>
            <section class="product-detail">
              <div class="product-title" [ngStyle]="{ 'color': titleColor?titleColor:textColor }">
                <a [ngStyle]="{ 'color': titleColor?titleColor:textColor }"
                  [routerLink]="[links[i]]">{{product.name}}</a>
              </div>
              <div class="product-price" [ngStyle]="{ 'color': titleColor?titleColor:textColor }">
                <a [ngStyle]="{ 'color': titleColor?titleColor:textColor }" [routerLink]="[links[i]]"> {{(currency$ |
                  async)}}{{
                  (product.promoPrice ? product.promoPrice :product.price) | number : '1.2-2'}} </a> <span
                  class="promo-price" *ngIf="product.promoPrice"
                  [ngStyle]="{ 'color': titleColor?titleColor:textColor+'bd' }"><a
                    [ngStyle]="{ 'color': titleColor?titleColor:textColor+'bd' }" [routerLink]="[links[i]]">
                    {{product.currency}}{{product.price | number :
                    '1.2-2'}} </a></span>
              </div>
              <div *ngIf="product.promoPrice" class="product-promo"
                [ngStyle]="{ 'color': titleColor?titleColor:textColor+'bd' }">PROMO
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>